import BUILDER_CHAPTERS from "./tours/builder-tours";
import PAGE_TOURS from "./tours/page-tours";
import type { TourDefinition } from "../types/tour.types";

export const TOURS: TourDefinition[] = [...PAGE_TOURS, ...BUILDER_CHAPTERS];

export const getTourById = (tourId: string): TourDefinition | undefined =>
  TOURS.find((tour) => tour.id === tourId);
